import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/LIB_settingValues'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class LIB_settingValuesStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "LIB_settingValuesStore",
			variables: false,
		})
	}
}

export async function load_LIB_settingValues(params) {
  await initClient()

	const store = new LIB_settingValuesStore()

	await store.fetch(params)

	return {
		LIB_settingValues: store,
	}
}
